<template>
    <div>
         <div class="mobile-content"  v-for="item in transactions" :key="item.rowId" @click="showModal(item)" v-if="!isMobile">
                <div class="mobile-content-item">
                    <div class="mobile-content-header">
                        <div class="mobile-content-name">
                            <p>{{item.storeName}}</p>
                        </div>
                        <div class="mobile-content-date">
                            <p>{{item.billDate | date}}</p>
                        </div>
                    </div>
                    <div class="mobile-content-body" :class="item.transactionType | typeClass(item.transactionType,item.isPartnerTransaction)">
                        
                        <div class="mobile-list-info-text">
                            <p>Сугалааны эрх:</p>
                        </div>
                        <div class="mobile-list-info-number">
                            <p>{{item.addedBonus | pricewithindex}}</p>
                        </div>
                    </div>
                    <div class="mobile-content-footer">
                        <p>Нийт дүн:</p>
                        <p>{{item.totalAmount | pricewithindexof}}</p>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:['transactions','isMobile'],
        methods:{
            showModal(value){
                this.$emit('showModal',value);
            },
        }
    }
</script>

<style scoped>
.mobile-content-item{
    margin-top:20px;
    padding-left: 20px;
    padding-right: 13px;
    padding-top:24px;
    width:100%;
    height: auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    box-shadow: 0px 1px 1px 0 rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
}
.mobile-content-header{
    margin-bottom:13px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    border-bottom:1px dotted rgba(0, 0, 0, 0.1);
}
.mobile-content-header div:nth-child(1){
    flex:1;
}
.mobile-content-header div:nth-child(1) p{
    margin-bottom:4px;
    opacity: 0.6;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
}
.mobile-content-header div:nth-child(2) p{
    margin:0;
    opacity: 0.6;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: right;
    color: rgba(0, 0, 0, 0.6);
}
.mobile-content-body{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    opacity: 0.5;
    border-radius: 3px;
    background-color: #f5f5f5;
}
.mobile-list-info-text{
    width:60%;
}
.mobile-list-info-number{
    width:40%;
}
.mobile-content-body div:nth-child(1) p,.mobile-content-body div:nth-child(3) p{
    opacity: 0.8;
    font-size: 13px;
    padding-top:14px;
    padding-left:18px;
    padding-bottom:13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
    color: rgba(0, 0, 0, 0.8);
    margin:0;
}
.mobile-content-body div:nth-child(3) p{
    padding-top:0;
}
.mobile-content-body div:nth-child(2) p,.mobile-content-body div:nth-child(4) p{
    padding-right: 11px;
    padding-top:15px;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: right;
    color: #000000;
    margin:0;
}
.mobile-content-body div:nth-child(4) p{
    padding-top:0;
}
.mobile-content-footer{
    display: flex;
    flex-direction: column;
}
.mobile-content-footer p{
    width:100%;
    margin-bottom:0;
    display: flex;
    justify-content: flex-end;
}
.mobile-content-footer p:nth-child(1){
    margin-top:12px;
    opacity: 0.6;
    font-size: 10px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: right;
    color: rgba(0, 0, 0, 0.6);
    text-transform: uppercase;
}
.mobile-content-footer p:nth-child(2){
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: right;
    color: #1660ab;
    margin-bottom:28px!important;
}
</style>